import { without, find } from 'lodash';
import { REMOVE_LOADING, SET_NEW_LOADING } from '../constants';

const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_NEW_LOADING:
      return [...state, action.payload];
    case REMOVE_LOADING:
      return without(state, find(state, action.payload));
    default:
      return state;
  }
};
